import { AttachmentMeta } from "@/indexedDB/types";
import { Loader, Play } from "lucide-react";
import useMediaAttachment from "@/middleware/hooks/attachments/useMediaAttachment";

type Props = {
  messageId: string;
  messageTimestamp: string;
  chatId: string;
  attachment: AttachmentMeta;
};

export default function MediaAttachment({
  messageId,
  messageTimestamp,
  chatId,
  attachment,
}: Props) {
  const { loading, attachmentUrl } = useMediaAttachment({
    messageId,
    messageTimestamp,
    chatId,
    attachment,
  });

  // TO DO => improve logic and spinner extraction
  return (
    <div className="relative aspect-square size-10">
      {loading && (
        <div className="absolute left-0 top-0 z-10 flex aspect-square size-full animate-pulse items-center justify-center rounded-sm bg-background align-middle">
          <Loader className="size-4 animate-spin text-secondary" />
        </div>
      )}
      {attachmentUrl && (
        <img
          className="ios-image-safe aspect-square size-full touch-manipulation select-none rounded-sm object-cover"
          src={attachmentUrl}
          alt=""
          draggable={false}
        />
      )}
      {attachment?.fileType.startsWith("video/") && (
        <div className="z-5 absolute left-0 top-0 flex aspect-square size-full items-center justify-center rounded-sm align-middle">
          <Play className="size-4" />
        </div>
      )}
    </div>
  );
}
